import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { GetCompanySetting, getStoreInformation } from "../../services/companyService";

const StoreHeaderImage = (storeId) => {
    const [topImage, setTopImage] = useState(
        'assets/images/profile_temp/bgheadermirrored.jpg'
    );

    const [logoImage, setLogoImage] = useState(
        'assets/images/profile_temp/profile1.png'
    );

     const [config, setConfig] = useState(null);


   const [pageCompanyConfig, setPageCompanyConfig] = useState(null);

    // useEffect(() => {
    //     try {
    //         const config = JSON.parse(
    //             localStorage.getItem("pageCompany_app_config")
    //         );
    //         setPageCompanyConfig(config);
    //         console.log("config value", config)
    //         if (config?.topBanner) {
    //             setTopImage(config.topBanner);
    //         }

    //         if (config?.logo) {
    //             setLogoImage(config.logo);
    //         }
    //     } catch (e) {
    //         console.error("Invalid pageCompany_app_config", e);
    //     }
    // }, []);

      useEffect(() => {
        console.log("storeId header", storeId)
        if (!storeId) return;
    
        const load = async () => {
          try {
            const data = await getStoreInformation(storeId);
            setConfig(data.data);
            console.log("company data", data.data)
            if (data.data?.topBanner) {
              setTopImage(data.data.topBanner);
            }
            if (data.data?.logo){
                setLogoImage(data.data.logo);
            }
          } catch (e) {
            console.error("Failed to load store info", e);
          }
        };
    
        load();
      }, [storeId]);

  return (
    <section className="storeSellerHeader">
        <div className="container">
            <div className="profil_imagebg" style={{backgroundImage:`url(${topImage})`}}>
                <div className="profile_data p-20">
                    <div className="d-flex align-items-center gap-10">
                        <div className="profile_image">
                            <img
                            src= {logoImage}
                            alt=''
                            className='image_profile h-100 w-auto'
                            />
                        </div>
                        <div className="profile_info">
                            <div className="profile_name">
                                Shop Name
                            </div>
                            <div className="profile_description mb-5">
                                shop description
                            </div>
                            <div className="profile_store_link">
                               <i class="ph-bold ph-link-simple"></i> linktree.com/shopnamelink
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mt-10">
                        <button className="btn_custom outline_white"><i class="ph ph-plus"></i> Follow</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default StoreHeaderImage;
